export default __webpack_public_path__ + "static/media/Letter-8.5-x-11in.d06d02c9.png";